export default __webpack_public_path__ + "static/media/adwordsBanner.08f8657d.webp";